"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Notice = _interopRequireDefault(require("./Notice"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const translate = {
  es: {
    ERROR_TITLE: 'Ha ocurrido un error',
    ERROR_DESCRIPTION: 'Se ha producido un error al intentar obtener la información'
  }
};
function NoticeError() {
  return /*#__PURE__*/_react.default.createElement(_Notice.default, {
    name: "error",
    title: translate['es'].ERROR_TITLE,
    description: translate['es'].ERROR_DESCRIPTION
  });
}
var _default = exports.default = NoticeError;